module.exports = __webpack_public_path__ + "img/phone.270fac1a.svg";